import "./Card.css";
import FormMain, { App } from "../FormMain/FormMain";

function Card() {
  return (
    <div className="my-card">
      <FormMain />
    </div>
  );
}

export default Card;
